module.exports = __webpack_public_path__ + "img/logo-loverfans-color.89f23f97.svg";